export const CLIENT_ENTRY_HEADER = 'X-Client-Entry'
export const CLIENT_ENTRY_VALUE = 'h5'

export const buildClientEntryHeaders = () => ({
  [CLIENT_ENTRY_HEADER]: CLIENT_ENTRY_VALUE
})
